import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'apps/landing/src/environments/environment';

@Component({
  selector: 'switch-level-dialog',
  template: `
    <div mat-dialog-content>
      <mat-form-field appearance="fill">
        <mat-label>Niveau</mat-label>
        <mat-select [(ngModel)]="selectedLevel" name="selectedLevel">
          <mat-option *ngFor="let level of levels" [value]="level">
            {{ level }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Fermer</button>
      <button mat-button [mat-dialog-close]="selectedLevel" cdkFocusInitial>
        Valider
      </button>
    </div>
  `
})
export class SwitchLevelDialog {
  levels = (environment as any)?.levels?.options;

  selectedLevel;

  constructor(
    public dialogRef: MatDialogRef<SwitchLevelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedLevel: string }
  ) {
    this.selectedLevel = data.selectedLevel;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
